// extracted by mini-css-extract-plugin
module.exports = {"langSwitcher":"styles_langSwitcher__3leuc","dark":"styles_dark__2eH_j","light":"styles_light__SK7U8"};